import { EditorState as AudioPatchData } from '@web-noise/sdk';
import { Effects } from 'services/store/remixer/types';
import { awsApi } from '../base';
import { environmentManager } from '../config';

const EffectUrls: Record<Effects, string> = <const>{
  [Effects.radio]: 'radio.json',
  [Effects.destroyer]: 'destroyer.json',
  [Effects.heavenLow]: 'heaven_low.json',
  [Effects.spaciousness]: 'spaciousness.json',
  [Effects.master]: 'master.json',
};

const { isProductionEnv } = environmentManager;
const folder = isProductionEnv ? 'prd' : 'dev';

const effectsApi = awsApi.injectEndpoints({
  endpoints: (build) => ({
    getEffect: build.query<AudioPatchData, Effects>({
      query: (effectName) => ({
        url: `/remixer_effects/${folder}/${EffectUrls[effectName]} `,
      }),
      transformResponse: (result: AudioPatchData) => result,
    }),
  }),
  overrideExisting: false,
});

export default effectsApi;
